(function () {
  'use strict';

  if (window.__plzRevealBooted) return;
  window.__plzRevealBooted = true;

  var SKIP_SELECTOR = [
    '.plz-shop-marquee',
    '.plz-hgr-ticker',
    '.plz-ann',
    '.plz-amb-marquee',
    '.plz-shop-divider',
    '.plz-hgr__spacer',
    '[data-plz-reveal="off"]',
    '.plz-vein',
    '.plz-vs',
    '#plz-vs-page',
    '.plz-amb',
    '.plz-footer-section',
    '.plz-footer-wrap',
    '.plz-footer',
    '.visually-hidden',
  ].join(', ');

  var HERO_SPLIT = [
    { root: '.plz-hgr-hero', parts: ['.plz-hgr-hero__media', '.plz-hgr-hero__info'] },
    { root: '.plz-hgr-why', parts: ['.plz-hgr-why__media', '.plz-hgr-why__content'] },
    { root: '.plz-hgr-how', parts: ['.plz-hgr-how__steps', '.plz-hgr-how__media'] },
    { root: '.plz-hgr-stack', parts: ['.plz-hgr-stack__text', '.plz-hgr-stack__media'] },
    { root: '.plz-shop-cmh-hero', parts: ['.plz-shop-cmh-hero__left', '.plz-shop-cmh-hero__right'] },
    { root: '.plz-cmh-hero', parts: ['.plz-cmh-hero__media', '.plz-cmh-hero__info'] },
    { root: '.plz-cmh-stack', parts: ['.plz-cmh-stack__text', '.plz-cmh-stack__media'] },
    { root: '.plz-cmh-why', parts: ['.plz-cmh-why__media', '.plz-cmh-why__text'] },
    { root: '.plz-cmh-how__layout', parts: ['.plz-cmh-how__content', '.plz-cmh-how__media'] },
    { root: '.plz-hero-split', parts: ['.plz-hero-split__content', '.plz-hero-split__media'] },
    { root: '.plz-ms-founder', parts: ['.plz-ms-founder__media', '.plz-ms-founder__content'] },
  ];

  var STAGGER_GROUPS = [
    { grid: '.plz-hgr-reviews__grid', item: '.plz-hgr-reviews__card' },
    { grid: '.plz-cmh-reviews__grid', item: '.plz-cmh-reviews__card' },
    { grid: '.plz-hgr-stats', item: '.plz-hgr-stats__item' },
    { grid: '.plz-shop-badge-strip', item: '.plz-shop-badge-card' },
    { grid: '.plz-cmh-formula__grid', item: '.plz-cmh-formula__card' },
    { grid: '.plz-ms-why__cards', item: '.plz-ms-why__card' },
    { grid: '.plz-amb-grid__cards', item: '.plz-amb-grid__card' },
  ];

  var HERO_SPLIT_PARTS = HERO_SPLIT.reduce(function (parts, cfg) {
    return parts.concat(cfg.parts);
  }, []).join(', ');

  var SECTION_BG_SELECTOR = [
    '.plz-section--cream',
    '.plz-section--pink',
    '.plz-section--navy',
    '.plz-section--blue',
    '.plz-section--white',
    'section.plz-section',
    'section[class*="plz-"]',
  ].join(', ');

  var observer;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isPlzShopBlock(el) {
    var parent = el && el.parentElement;
    if (!parent || !parent.classList.contains('plz-shop')) return false;
    return Array.from(el.classList).some(function (className) {
      return className.indexOf('plz-shop-') === 0;
    });
  }

  function hasSectionBackground(el) {
    if (!el || !el.matches) return false;
    if (el.matches(SECTION_BG_SELECTOR)) return true;
    if (el.matches(HERO_SPLIT_PARTS)) return true;
    if (isPlzShopBlock(el)) return true;
    return false;
  }

  function shouldSkip(el) {
    if (!el || el.matches(SKIP_SELECTOR)) return true;
    if (el.closest(SKIP_SELECTOR)) return true;
    if (hasSectionBackground(el)) return true;
    return false;
  }

  function pushTarget(targets, seen, el, delay) {
    if (!el || shouldSkip(el) || seen.has(el)) return;
    seen.add(el);
    targets.push({ el: el, delay: delay || 0 });
  }

  function tryHeroSplit(root, targets, seen) {
    for (var i = 0; i < HERO_SPLIT.length; i++) {
      var cfg = HERO_SPLIT[i];
      var match = root.matches && root.matches(cfg.root) ? root : root.querySelector(cfg.root);
      if (!match) continue;

      var parts = cfg.parts
        .map(function (sel) {
          return match.querySelector(sel);
        })
        .filter(Boolean);

      if (parts.length !== cfg.parts.length) continue;

      parts.forEach(function (part, idx) {
        pushTarget(targets, seen, part, idx * 110);
      });
      return true;
    }
    return false;
  }

  function tryStaggerGrids(root, targets, seen) {
    var handled = false;
    STAGGER_GROUPS.forEach(function (group) {
      root.querySelectorAll(group.grid).forEach(function (grid) {
        var items = grid.querySelectorAll(group.item);
        if (!items.length) return;
        handled = true;
        items.forEach(function (item, idx) {
          pushTarget(targets, seen, item, idx * 70);
        });
      });
    });
    return handled;
  }

  function collectFromBlock(block, targets, seen) {
    if (shouldSkip(block)) return;
    if (tryHeroSplit(block, targets, seen)) return;
    if (tryStaggerGrids(block, targets, seen)) return;
    pushTarget(targets, seen, block, 0);
  }

  function collectFromShopifySection(sectionEl, targets, seen) {
    var monoShop = sectionEl.querySelector('.plz-shop');
    if (monoShop) {
      monoShop.querySelectorAll(':scope > *').forEach(function (child) {
        collectFromBlock(child, targets, seen);
      });
      return;
    }

    var blocks = sectionEl.querySelectorAll(':scope > section.plz-section, :scope > section[class*="plz-"], :scope > .plz-section');
    if (blocks.length) {
      blocks.forEach(function (block) {
        collectFromBlock(block, targets, seen);
      });
      return;
    }

    var inner = sectionEl.querySelector('section.plz-section, .plz-section, section[class*="plz-"]');
    if (inner) collectFromBlock(inner, targets, seen);
  }

  function collectTargets(root) {
    var targets = [];
    var seen = new Set();
    var scope = root || document;
    var main = scope.querySelector('#MainContent') || scope;

    main.querySelectorAll('.shopify-section').forEach(function (section) {
      collectFromShopifySection(section, targets, seen);
    });

    return targets;
  }

  function markReveal(el, delay) {
    if (!el || el.classList.contains('plz-reveal')) return;
    el.classList.add('plz-reveal');
    if (delay) el.style.setProperty('--plz-reveal-delay', delay + 'ms');
  }

  function show(el) {
    el.classList.add('is-visible');
  }

  function isNearViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.94 && rect.bottom > 0;
  }

  function initReveal(root) {
    if (prefersReducedMotion()) {
      collectTargets(root).forEach(function (item) {
        show(item.el);
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            show(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
      );
    }

    collectTargets(root).forEach(function (item) {
      markReveal(item.el, item.delay);
      if (item.el.classList.contains('is-visible')) return;

      observer.observe(item.el);

      if (isNearViewport(item.el)) {
        requestAnimationFrame(function () {
          show(item.el);
          observer.unobserve(item.el);
        });
      }
    });
  }

  function boot() {
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initReveal(event.target);
    });
  }
})();
